module.exports = __webpack_public_path__ + "static/ipad-pro_gaming-a12x-chip_10302018-bef57e1ae47abe49915bed98c6f4ef7d.jpg";